module.exports = __webpack_public_path__ + "img/img_helper_receipt.ad96b065.svg";